import { Menu, Table } from '@mantine/core';
import { IconEdit, IconTrash } from '@tabler/icons-react';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { DeleteModal } from '../../../components/DeleteModal';
import { TableRowMenu } from '../../../components/TableRowMenu';
import { useModal } from '../../../hooks/useModal';
import { defaultIconStyle } from '../../../theme/styling/iconStyling';
import { mutate } from '../../../util/api/mutate';
import type {
	DepartmentDto,
	UpsertDepartmentDto,
} from '../types/DepartmentDto';
import { EditDepartmentModal } from './EditDepartmentModal';
import { KeyedRow } from '../../../components/KeyedRow';

interface DepartmentRowProps {
	department: DepartmentDto;
	triggerListUpdate: () => void;
}

export function DepartmentRow({
	department,
	triggerListUpdate,
}: DepartmentRowProps) {
	const { organisation } = useParams();

	const editModal = useModal();
	const deleteModal = useModal();

	const editDepartmentDto = useMemo(() => {
		const editDepartment: UpsertDepartmentDto = {
			id: department.id.toString(),
			departmentName: department.name,
			groupId: department.groupId,
			shouldDisplay: department.shouldDisplay ? 'True' : 'False',
		};

		return editDepartment;
	}, [department]);

	const deleteMutation = mutate<boolean>(
		`${organisation}/departments/delete/${department.id.toString()}`,
	);

	return (
		<>
			<DeleteModal
				close={deleteModal.close}
				isOpened={deleteModal.isOpen}
				titleType={'Department'}
				itemDescription={department.name}
				mutation={deleteMutation}
				onComplete={() => triggerListUpdate()}
			/>
			<EditDepartmentModal
				isOpened={editModal.isOpen}
				close={editModal.close}
				triggerListUpdate={triggerListUpdate}
				initialDepartment={editDepartmentDto}
			/>
			<KeyedRow>
				<Table.Td>{department.name}</Table.Td>
				<Table.Td>{department.groupName}</Table.Td>
				<Table.Td>{department.shouldDisplay ? <i>True</i> : <i>False</i>}</Table.Td>
				<Table.Td>
					<TableRowMenu>
						<Menu.Item
							leftSection={<IconEdit {...defaultIconStyle} />}
							onClick={() => editModal.open()}
						>
							Edit
						</Menu.Item>
						<Menu.Item
							leftSection={<IconTrash {...defaultIconStyle} />}
							onClick={() => deleteModal.open()}
							c={'red'}
						>
							Delete
						</Menu.Item>
					</TableRowMenu>
				</Table.Td>
			</KeyedRow>
		</>
	);
}
